<template>
  <main class="grid" style="opacity: 0; visibility: hidden;">
    <div class="container title">
      <div class="title__inner">
        <h1 data-anim="title" v-html="data.title"></h1>
      </div>
    </div>
    <div
      class="container--small content"
      data-anim="text"
      v-html="data.text"
    />
  </main>
</template>

<script>
export default {
  name: 'Manifesto',

  data() {
    return {
      data: this.$store.state.firebase.manifesto,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  min-height: 60vh;

  @include mq($and: $is-touch-device) {
    min-height: 300px;
  }

  &__inner {
    position: relative;
    overflow: hidden;

    h1 {
      margin: 0;
    }
  }
}
.content {
  padding: 0 0 rem(100px) 0;
}
</style>
